import React, {Component} from 'react';
import AppLink from "../AppLink";
import SubMenu from "./SubMenu";
import DottedLoader from "../DottedLoader";
import Icon from "../Icon";

class Menu extends Component {
  static INTERVAL = 50;

  constructor(props) {
    super(props);

    this.state = {
      open: false
    };

    this.onPageClick = this.onPageClick.bind(this)
  }

  componentDidMount() {
    window.addEventListener('click', this.onPageClick);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.onPageClick);
  }

  onMouseEnter(e) {
    let target = e.target.closest("li");

    clearTimeout(this._leaveTimeout);
    clearTimeout(this._enterTimeout);
    this._enterTimeout = setTimeout(() => {
      document.querySelectorAll('.top-menu li.hover').forEach((elem) => {
        elem.classList.remove("hover");
      });

      target.classList.add("hover");
      this.setState({
        open: true
      });
    }, this.state.open ? Menu.INTERVAL : 100)
  }

  onMouseLeave(e) {
    let target = e.target.closest("li");

    clearTimeout(this._enterTimeout);
    clearTimeout(this._leaveTimeout);
    this._leaveTimeout = setTimeout(() => {
      target.classList.remove("hover");
      this.setState({
        open: false
      });
    }, this.state.open ? Menu.INTERVAL : 100)
  }

  onPageClick() {
    document.querySelectorAll('.top-menu li.hover').forEach((elem) => {
      elem.classList.remove("hover");
    });
    this.setState({
      open: false
    });
  }

  render() {
    const { menu, loading } = this.props;

    return (
      <nav>
        <section className={'container'}>
          <ul className={'top-menu'}>
            {loading ? (
              <React.Fragment>
                {[1,2,3].map(num => {
                  return <li key={num}><DottedLoader /></li>;
                })}
              </React.Fragment>
            ) : (
              <React.Fragment>
                {menu.map(item => {
                  return (
                    <li onMouseEnter={this.onMouseEnter.bind(this)} onMouseLeave={this.onMouseLeave.bind(this)} key={item.slug || item.url} className={item.children && item.children.length > 0 ? ('with-submenu columns-' + Math.ceil(item.children.length / 6)) : ''}>
                      <AppLink to={(item.slug || item.url)} type={'nav'} className={item.children && item.children.find(c => c.url === window.location.pathname) && "active"}>
                        {item.icon && <Icon icon={item.icon} />} <span>{item.name || item.title}</span>
                      </AppLink>
                      {item.children && item.children.length > 0 && (
                        <SubMenu item={item} />
                      )}
                    </li>
                  )
                })}
              </React.Fragment>
            )}
          </ul>
        </section>
      </nav>
    );
  }
}

export default Menu;